import { request } from '../../api/client';
import type { AssetRelations, RelationChanges } from './relationsModel';

export const relationsApi = {
  load: (id: number, signal?: AbortSignal) => request<AssetRelations>(`/api/creation/assets/${id}/relations`, { signal }),
  save: (id: number, changes: RelationChanges) => request<{ version: string }>(`/api/creation/assets/${id}/relations`, { method: 'POST', body: changes }),
};
